export const authErrorHandler = (error: any): string => {
  switch (error.code) {
    case 'auth/invalid-email':
      return 'メールアドレスが正しい形式で入力されていません。';
    case 'auth/user-disabled':
      return '無効なユーザーです。';
    case 'auth/user-not-found':
      return '存在しないユーザーです。';
    case 'auth/wrong-password':
      return '登録されたパスワードと異なっています。';
    case 'auth/email-already-in-use':
      return 'すでに登録されているメールアドレスです。ログインしてください。';
    case 'auth/weak-password':
      return 'パスワードの強度が十分ではありません。';
    case 'auth/user-service-sign-error':
      return '会員登録に失敗しました';
    default:
      return 'ログインに失敗しました。再度お試しください。';
  }
};
